const ajuste_estimativa_de_matricula_reordenamento_mudanca_de_perfil = {
  path: "/ajuste-estimativa-de-matricula-reordenamento-mudanca-de-perfil",
  redirect: "/ajuste-estimativa-de-matricula-reordenamento-mudanca-de-perfil",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Ajuste Estimativa de Matrícula Reordenamento",
  },
  children: [
    {
      path: "/ajuste-estimativa-de-matricula-reordenamento-mudanca-de-perfil",
      name: "ajuste_estimativa_de_matricula_reordenamento_mudanca_de_perfil",
      component: () =>
        import(
          "@/views/AjusteDeEstimativaDeMatriculaReordenamentoMudancaDePerfil/AjusteDeEstimativaDeMatriculaReordenamentoMudancaDePerfil.vue"
        ),
    },
  ],
};

export { ajuste_estimativa_de_matricula_reordenamento_mudanca_de_perfil };
